import React, { useEffect, useState } from "react";
import {
  transformResultsToCompProfileData,
  formatBoldText,
  replaceMomentumWithSpan,
} from "../../../../../services/commonService";
import InsightTable from "../../InsightTable";
import { useParams } from "react-router-dom";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function InnovationThemeRadar({ innovatonThemeRadar, compView }) {
  const { clientName, competitorName } = useParams();
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");

  const [columns, setColumns] = useState([]);
  const [sidebarColumns, setSidebarColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  let allMetrics = [];
  useEffect(() => {
    if (compView === "quantitative") {
      allMetrics = [
        // { key: "name", label: "Name" },
        { key: "momentum", label: "Momentum" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    } else {
      allMetrics = [
        // { key: "name", label: "Name" },
        { key: "description", label: "Description" },
        { key: "momentum", label: "Momentum" },
        { key: "signal", label: "Signal" },
        { key: "source", label: "Source" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    }
  }, [compView]);

  // const dummyData = [
  //   {
  //     theme: {
  //       value: "AI-enabled Clinical Workflow Management",
  //     },
  //     description: {
  //       value:
  //         "Intelligent preference card optimization and predictive replenishment.",
  //     },
  //     momentum: {
  //       value: "Rising",
  //     },
  //     signal: {
  //       value: "Patent filings + AI pilot launches with major IDNs.",
  //     },
  //   },
  // ];

  useEffect(() => {
    // setTabData(dummyData);
    const transformed = transformResultsToCompProfileData(innovatonThemeRadar);
    const replacedData = replaceMomentumWithSpan(transformed);
    setTabData(transformed);
    setTableBelowDescription(
      // formatBoldText(innovatonThemeRadar?.[0]?.response?.["tableComments"])
      <ParsedTextWithLinks
        text={innovatonThemeRadar?.[0]?.response?.["tableComments"] || ""}
      />
    );
  }, [innovatonThemeRadar]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  const filtersConfig = [
    {
      key: "momentum",
      label: "Momentum",
      type: "chips",
      options: ["Rising", "Stable", "Cooling"],
      defaultValue: [], // for chips start empty
    },
  ];

  return (
    <div className="innovation_radar_wrapper">
      <InsightTable
        title="Innovation Theme Radar"
        subtitle={`Top innovation themes based on ${
          competitorName ?? "Tailored Chemical Products"
        }’s R&D focus, IP signals, and product momentum.`}
        data={tabData}
        metrics={columns}
        rowIdentifier="name"
        // belowTableDescription={tableBelowDescription}
        actions={actions}
        filtersConfig={filtersConfig}
      />
    </div>
  );
}

export default InnovationThemeRadar;
